<script>
    import { globalSizes, personalLinks } from '../store';
    import LoaderSkeleton from '../shared/LoaderSkeleton.svelte';
    import PeronalLink from '../PeronalLink.svelte';

    let scrollY;
</script>

<svelte:window bind:scrollY={scrollY} />

<div class="container" style={scrollY >= $globalSizes.heroH ? `margin-top: ${$globalSizes.navbarH}px` : ''}>
    <h2><span class="font-light">Where to</span> Find Me</h2>

    { #if $personalLinks.length > 0 }
        { #each $personalLinks as link }
            <PeronalLink {link} />
        { /each }
    { :else }
        <LoaderSkeleton display="inline-flex" maxWidth="150px" margin="0 15px 0 0" height="32px" mobileMaxWidth="100%" mobileHeight="37px" borderRadius="300px" />
        <LoaderSkeleton display="inline-flex" maxWidth="150px" margin="0 15px 0 0" height="32px" mobileMaxWidth="100%" mobileHeight="37px" borderRadius="300px" />
        <LoaderSkeleton display="inline-flex" maxWidth="150px" margin="0 15px 0 0" height="32px" mobileMaxWidth="100%" mobileHeight="37px" borderRadius="300px" />
    { /if }
</div>

<style lang="less">
    h2 {
        margin-bottom: 25px;
    }
</style>